import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfileContactSection,
} from './StaffProfileTemplate';

const KhrieletuonuoYhomeProfile = () => {
  const person = {
    id: 'khrieletuonuo-yhome',
    name: 'Khrieletuonuo Yhome',
    honorific: 'Ms',
    title: 'Assistant Researcher',
    affiliation: 'The Highland Institute, Kohima, Nagaland',
    image: 'https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/3t1t9lro_Khrieletuonuo.jpg',
    email: 'khriele@highlandinstitute.org',
    category: 'Research Staff',
    testid: 'khrieletuonuo-yhome-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            "Khrieletuonuo Yhome is an early-career researcher based at The Highland Institute. She holds Bachelor's and Master's degrees in Zoology, and her work spans environmental observation, cultural research, and community-based inquiry.",
            'Her current focus involves archival digitisation, metadata documentation, and qualitative research support. She has also participated in ethnographic fieldwork examining urban social interactions in Kohima, and has contributed transcription, documentation, and editorial support to institutional research initiatives.',
            "Khrieletuonuo's emerging areas of interest include environmental change, biodiversity, folklore, human–animal relations, and Indigenous ecological knowledge. Alongside research, she engages in creative and reflective writing and contributes to collaborative literary and public-facing publications.",
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Research Foci and Areas of Work">
        <p className="text-stone-700 leading-relaxed mb-4">
          Khrieletuonuo Yhome's work brings together environmental studies, cultural research, and field-based inquiry, focusing on how local knowledge systems inform wider ecological and social questions.
        </p>
        <p className="text-stone-700 font-medium mb-4">Her particular interests include:</p>
        <ProfileBullets
          items={[
            'Environmental observation and ecological change',
            'Biodiversity and conservation',
            'Indigenous ecological knowledge',
            'Folklore and cultural memory',
            'Human–animal relations and applied zoological perspectives',
            'Urban social dynamics and migration',
            'Archival documentation and visual histories',
            'Qualitative and ethnographic fieldwork',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            <>
              At The Highland Institute, Khrieletuonuo Yhome is currently involved in the project <strong>"Visual Histories of Northeast India: Digitising the Anthropological Photographs of Ahmed Hossain"</strong>, in collaboration with the Modern Endangered Archives Program, UCLA. Her role includes digitisation, metadata creation, and archival organisation related to photographic collections documenting the cultural and social histories of Northeast India, with a focus on Nagaland.
            </>,
            'Her institutional contributions also include support for newsletter publication, editorial coordination, and library accessioning and organisation.',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Selected Publications and Knowledge Outputs">
        <p className="text-stone-700 leading-relaxed mb-4">Selected blogs and public-facing contributions include:</p>
        <ul className="space-y-3 not-prose">
          <li className="text-stone-700 pl-4 border-l-2 border-green-600">
            <a
              href="https://blogs.highlanderpress.org/index.php/2026/02/23/kohimas-market-a-contested-space-between-locals-and-non-locals/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-700 hover:text-green-800 underline break-all"
            >
              Kohima's Market: A Contested Space Between Locals and Non-Locals
            </a>
          </li>
          <li className="text-stone-700 pl-4 border-l-2 border-green-600">
            <a
              href="https://blogs.highlanderpress.org/index.php/2026/02/17/apis-cerana-bee-venom-and-its-application-in-soap-making/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-700 hover:text-green-800 underline break-all"
            >
              Apis cerana Bee Venom and its Application in Soap Making
            </a>
          </li>
          <li className="text-stone-700 pl-4 border-l-2 border-green-600">
            Contributor to <em>The Storykeeper Book of Mothers</em>, edited by Vishü Rita Krocha, with the poem "The First Voice I Knew", PenThrill Publication House, 2026.
          </li>
        </ul>
      </ProfileSection>

      <ProfileSection title="Postgraduate Qualification">
        <ProfileBullets items={['MSc in Zoology']} />
      </ProfileSection>

      <ProfileContactSection
        email={person.email}
        role="Assistant Researcher, The Highland Institute"
        testidPrefix="khrieletuonuo"
        scholarlyProfiles={[
          {
            label: 'LinkedIn',
            url: 'https://www.linkedin.com/in/khrieletuonuo-yhome-yhome',
            testid: 'khrieletuonuo-linkedin-link',
          },
        ]}
      />
    </StaffProfileTemplate>
  );
};

export default KhrieletuonuoYhomeProfile;
